import generalSection from "../_section/section.class";
import {adminEmploymentContractUpload, userEmploymentContractUpload} from "./upload";
import DataForm from "./DataForm";

export class userEmploymentContractSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userEmploymentContractUpload);
        // Add missing date error

    }
}

export class adminEmploymentContractSection extends userEmploymentContractSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminEmploymentContractUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.activeUploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }


    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'Dated',
                    value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                }]
            }
        ]
    }
}